import * as React from 'react'
import { n, pipe, O, Ord as _Ord, RA, RR, s, flip, identity } from '@packages/prelude'
import styled from 'styled-components'
import { FilterItem } from './FilterItem'

const FilterWrapper = styled.div`
  display: flex;
  justify-content: center;
`
const FilterBar = styled.ul``

interface CategoryFilter {
  id: string
  name: string
  slug: string
  icon: O.Option<string>
}

interface CategoriesFilterProps {
  categories: RR.ReadonlyRecord<string, CategoryFilter>
  handleSetFilter: (id: string) => void
  activeFilter: string
}

const Ordering: RR.ReadonlyRecord<string, number> = {
  'bremer-koepfe': 1,
  events: 2, // note: 'events' refers to the category slug 'events'
  dates: 3, // note: 'dates' refers to the PostType 'events'
  gastro: 4,
  lifestyle: 5,
  raffles: 6,
  podcasts: 7
}

const Ord = _Ord.fromCompare<CategoryFilter>((a, b) => {
  return O.getOrd<number>(n.Ord).compare(RR.lookup(a.slug, Ordering), RR.lookup(b.slug, Ordering))
})

export const CategoriesFilter: React.VFC<CategoriesFilterProps> = ({ categories, handleSetFilter, activeFilter }) => {
  return (
    <FilterWrapper>
      <FilterBar className="btn-group filter-bar">
        {pipe(
          categories,
          RR.collect(s.Ord)(flip(identity)),
          RA.sort(Ord),
          RA.map(category => (
            <FilterItem
              active={category.id === activeFilter}
              name={category.name}
              icon={category.icon}
              key={category.name}
              onClick={() => handleSetFilter(category.id)}
            />
          ))
        )}
      </FilterBar>
    </FilterWrapper>
  )
}
